let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eaKxX")).then(() => parcelRequire('UV6Gb'));